import './index.scss'

$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$(".search").click(function(){
    $(".pc-header").hide();
    $(".search-box").css("display","flex");
})
$(".search-out").click(function(){
    $(".pc-header").show();
    $(".search-box").hide();
})
$(".nav li").hover(function(){
    $(".header-bg").show()
    $(this).find(".navchild").css("display","flex");
},function(){
    $(".header-bg").hide()
    $(this).find(".navchild").css("display","none");
})
$(".nav li:first").hover(function(){
    $(".header-bg").hide()
})
$(".nav li:last").hover(function(){
    $(".header-bg").hide()
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
//滚动定位
$(document).ready(function() {
    if (location.hash) {
        setTimeout(function() {
            var targetOffset = $(location.hash).offset().top;
        console.log(targetOffset)
            $('html, body').animate({
                scrollTop: targetOffset - 98
            }, 500);
        }, 10);
    }
});
  